import { render, staticRenderFns } from "./WorkerListItem.vue?vue&type=template&id=aec06dc8&scoped=true"
import script from "./WorkerListItem.vue?vue&type=script&lang=js"
export * from "./WorkerListItem.vue?vue&type=script&lang=js"
import style0 from "./WorkerListItem.vue?vue&type=style&index=0&id=aec06dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec06dc8",
  null
  
)

export default component.exports